import React, { useEffect, useRef } from 'react';
import InitialContext from 'state/static-data/InitialContext';
import 'swiper/css/bundle';
import { register } from 'swiper/element/bundle';
import CustomerTestimonialCard from './customer-testimonial-widget-card';
import './index.scss';

register();

interface CustomerTestimonialText {
    text: string;
    author: string;
}

export interface TestimonialLayout {
    slidesPerView: number;
    spaceBetween: number;
    // use this rather than margin to avoid white gap when sliding.
    slidesOffsetBefore: number;
    slidesOffsetAfter: number;
}

export interface CustomerTestimonialWidgetAttr {
    testimonials: CustomerTestimonialText[];
    style?: {
        card?: {
            backgroundColor?: string;
        };
        pagination?: {
            bulletColor?: string;
        };
    };
    layout?: {
        default?: TestimonialLayout;
        breakpoints?: {
            [key: number]: TestimonialLayout;
        };
    };
}

const CustomerTestimonialWidget = () => {
    const swiperElRef = useRef(null);
    const widgetAttr: CustomerTestimonialWidgetAttr = InitialContext.getCustomerTestimonialWidgetAttributes();

    if (!widgetAttr.testimonials.length) {
        return <></>;
    }

    useEffect(() => {
        const swiperContainer: any = swiperElRef.current;

        const params = {
            a11y: true,
            injectStyles: [
                `
                .swiper-pagination-bullet {
                  background: ${widgetAttr?.style?.pagination?.bulletColor ?? '#3140B3'};
                }
                `,
            ],

            // default settings
            slidesPerView: 1.2,
            spaceBetween: 10,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            // override if any
            ...widgetAttr.layout?.default,

            breakpoints: widgetAttr.layout?.breakpoints ?? {
                450: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },

            keyboard: {
                enabled: true,
            },
            pagination: {
                clickable: true,
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, []);

    return (
        <div className='customer-testimonial'>
            <swiper-container ref={swiperElRef} init={false}>
                {widgetAttr.testimonials.map((attr, i) => (
                    <swiper-slide>
                        <CustomerTestimonialCard
                            author={attr.author}
                            text={attr.text}
                            key={i}
                            style={{ backgroundColor: widgetAttr?.style?.card?.backgroundColor ?? '#FFFFFF' }}
                        ></CustomerTestimonialCard>
                    </swiper-slide>
                ))}
            </swiper-container>
        </div>
    );
};
export default CustomerTestimonialWidget;
